@if (!isUiTest) {
    <div style="height:240px;">
        <div class="security-history-header-block left">Attributes of this security have been edited as noted below:</div>
        <div class="right" style="margin-right: 1px;">
      <span class="right" style="margin-right: 3px;">
          <img id="exportLink" src="../../assets/images/download006E99.svg" (click)="exportHistory()" tooltip [tooltipTitle]="'Export'" style="cursor:pointer;">
      </span>
        </div>
        <div style="height:210px;">
            <irb-inventory-grid
                    [style.width]="'100%'"
                    [style.height]="'100%'"
                    [showSideBar]="false"
                    [gridOptions]="gridOptions"
                    [frameworkComponents]={}
                    (gridReady)="onGridReady($event)"></irb-inventory-grid>
        </div>
    </div>
}

